import { useContext, useMemo, useState, useEffect } from "react";
import { useAuth0V2 } from "@stadium/services/auth0";

import { FeatureFlagProvider } from "@stadium/services/launch-darkly";
import { CurrentUserContext } from "@contexts/current-user-provider";
import { getClientIpFromGeoCookie } from "@stadium/helpers/cookie";

import {
  getIsFetchingConfig,
  getLdAnonymousSecureModeHash,
} from "@stadium/redux-utils/selectors/configSelector";
import { useConfig } from "@stadium/hooks/lib/use-config";

import { LAUNCH_DARKYLY_CLIENT_ID } from "@constants/env-variables";
import { LAUNCH_DARKLY_ANONYMOUS_USER_CONFIG } from "@stadium/services/launch-darkly/constants";

const LaunchDarklyWrapper = ({ children }) => {
  const [clientIp, setClientIp] = useState(null);
  useEffect(() => {
    setClientIp(getClientIpFromGeoCookie());
  }, []);
  const { isLoading, isAuthenticated } = useAuth0V2();
  const { currentUserData, ldData } = useContext(CurrentUserContext);
  const { name, email } = currentUserData;

  const { userKey: key, secureModeHash: hash } = ldData;

  const ldAnonymousSecureModeHash = useConfig(getLdAnonymousSecureModeHash);
  const isFetchingConfig = useConfig(getIsFetchingConfig);

  const isReadyForInit = !isFetchingConfig && !isLoading && (isAuthenticated ? !!email : true);

  const configurations = useMemo(() => {
    if (!isReadyForInit) return {};

    const baseContext = key
      ? { key, name, email, kind: "user" }
      : LAUNCH_DARKLY_ANONYMOUS_USER_CONFIG;
    const context = clientIp ? { ...baseContext, ip: clientIp } : baseContext;

    return {
      context,
      options: { hash: hash || ldAnonymousSecureModeHash, disableSyncEventPost: true },
    };
  }, [isReadyForInit, key, name, email, hash, ldAnonymousSecureModeHash, clientIp]);

  return (
    <FeatureFlagProvider
      isReadyForInit={isReadyForInit}
      clientSideID={LAUNCH_DARKYLY_CLIENT_ID}
      configurations={configurations}
    >
      {children}
    </FeatureFlagProvider>
  );
};

export default LaunchDarklyWrapper;
